import { render } from "./PrepaidRechargeSuccess.vue?vue&type=template&id=72a12185&ts=true"
import script from "./PrepaidRechargeSuccess.vue?vue&type=script&lang=ts"
export * from "./PrepaidRechargeSuccess.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__